/* tslint:disable */
/* eslint-disable */
/**
 * Subscription App API
 * Provides management of all subscription operations at subscription app tier.
 *
 * The version of the OpenAPI document: 1.11.2
 * Contact: Pankaj.Gautam@Amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentStatus = {
    Initiated: 'INITIATED',
    InitiatedFailed: 'INITIATED_FAILED',
    PartialAuthorized: 'PARTIAL_AUTHORIZED',
    Authorized: 'AUTHORIZED',
    AuthorizeFailed: 'AUTHORIZE_FAILED',
    PartialCaptured: 'PARTIAL_CAPTURED',
    Captured: 'CAPTURED',
    CapturedFailed: 'CAPTURED_FAILED',
    Void: 'VOID',
    Verified: 'VERIFIED',
    InitiateRefund: 'INITIATE_REFUND',
    Refunded: 'REFUNDED',
    Awaited: 'AWAITED',
    Aborted: 'ABORTED',
    Cancelled: 'CANCELLED',
    CardExpired: 'CARD_EXPIRED',
    Failed: 'FAILED',
    CancelPending: 'CANCEL_PENDING',
    CancelFailed: 'CANCEL_FAILED'
} as const;
export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];


export function PaymentStatusFromJSON(json: any): PaymentStatus {
    return PaymentStatusFromJSONTyped(json, false);
}

export function PaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentStatus {
    return json as PaymentStatus;
}

export function PaymentStatusToJSON(value?: PaymentStatus | null): any {
    return value as any;
}

